import { registerRenderer } from './registry.js'

import NumericRenderer from './NumericRenderer.tsx'
import StringRenderer from './StringRenderer.tsx'
import TimelineRenderer from './TimelineRenderer.tsx'
import PhotoRenderer from './PhotoRenderer.tsx'
import MultiSelectRenderer from './MultiSelectRenderer.tsx'

export const registerAllRenderers = () => {
  //console.log("Registering all renderers")
  registerRenderer(NumericRenderer)
  registerRenderer(StringRenderer)
  registerRenderer(TimelineRenderer)
  registerRenderer(PhotoRenderer)
  registerRenderer(MultiSelectRenderer)
}
